(function () {
  if (window.kwoStickyLoaded) return;
  window.kwoStickyLoaded = true;
  if (!document.querySelector('.kwo-polish-flag')) return;

  var tries = 0;
  var FORM = '[id$="__product-form"]';

  var CSS =
    '.kwo-sticky{position:fixed;left:0;right:0;bottom:0;z-index:20;display:flex;align-items:center;gap:12px;padding:10px 15px calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid rgba(28,27,25,.1);box-shadow:0 -6px 20px rgba(0,0,0,.08);transform:translateY(100%);transition:transform .2s ease}' +
    '.kwo-sticky.is-visible{transform:translateY(0)}' +
    '.kwo-sticky__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;line-height:1.2}' +
    '.kwo-sticky__label{font-size:12px;color:#6b6a58;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.kwo-sticky__price{font-family:Oswald,sans-serif;font-size:20px;font-weight:700;color:#1c1b19}' +
    '.kwo-sticky__btn{flex:none;height:46px;padding:0 22px;border:0;border-radius:6px;background:#74724c;color:#fff;font-family:Oswald,sans-serif;font-weight:700;font-size:14px;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}' +
    '.kwo-sticky__btn:disabled{opacity:.5;cursor:default}' +
    'body.kwo-sticky-on{padding-bottom:72px}' +
    '@media screen and (min-width:750px){.kwo-sticky{display:none!important}body.kwo-sticky-on{padding-bottom:0}}' +
    '@media (prefers-reduced-motion:reduce){.kwo-sticky{transition:none}}';

  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function q(sel) { return document.querySelector(FORM + ' ' + sel); }
  function atc() { return q('.product--add-to-cart-button'); }
  function priceText() {
    var pe = q('[data-block-id^="price"]');
    if (!pe) return '';
    return text(pe.querySelector('.price--sale-price') || pe.querySelector('.price--regular-price') || pe);
  }

  function init() {
    if (!atc()) return false;
    var bundle = document.querySelector('section-store--bundle-block');
    var hasBundle = !!(bundle && (bundle.getAttribute('data-short-ids') || '').trim());
    if (hasBundle && !(bundle.shadowRoot && bundle.shadowRoot.querySelector('.bundle-option .title'))) return false;
    build(hasBundle ? bundle : null);
    return true;
  }

  function build(bundle) {
    var productTitle = text(q('h1')) || document.title;
    var hasOptions = !bundle && !!q('[data-block-id="options"] variant-dropdown, [data-block-id="options"] select, [data-block-id="options"] input[type="radio"]');
    var idInput = q('form input[name="id"]');
    var startId = idInput ? idInput.value : '';
    var touched = /[?&]variant=/.test(location.search);
    if (hasOptions) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-block-id="options"]') && e.target.closest('[role="option"], .dropdown-list li, label, input')) touched = true;
      });
      document.addEventListener('change', function (e) {
        if (e.target.closest('[data-block-id="options"]')) touched = true;
      });
    }

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'kwo-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Snel toevoegen');
    var info = document.createElement('div');
    info.className = 'kwo-sticky__info';
    var label = document.createElement('span');
    label.className = 'kwo-sticky__label';
    var price = document.createElement('b');
    price.className = 'kwo-sticky__price';
    info.appendChild(label);
    info.appendChild(price);
    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'kwo-sticky__btn';
    bar.appendChild(info);
    bar.appendChild(action);
    document.body.appendChild(bar);

    function state() {
      if (!bundle) {
        var cur = q('form input[name="id"]');
        if (hasOptions && cur && cur.value !== startId) touched = true;
        var p = priceText();
        if (hasOptions && !touched) {
          return { label: productTitle, price: p, ready: false, text: 'Kies opties' };
        }
        return { label: productTitle, price: p, ready: true };
      }
      var opts = [].slice.call(bundle.shadowRoot.querySelectorAll('.bundle-option'));
      var picked = null;
      opts.forEach(function (o) {
        var input = o.querySelector('.bundle-option-input');
        if (input && input.checked) picked = o;
      });
      function total(o) { return text(o && o.querySelector('.price-total .discounted')); }
      if (picked) {
        return { label: text(picked.querySelector('.title')), price: total(picked), ready: true };
      }
      return { label: 'Vanaf', price: total(opts[0]), ready: false };
    }

    var observed = null;
    var io = null;
    function watch() {
      var btn = atc();
      if (!btn || btn === observed || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      observed = btn;
      io = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('kwo-sticky-on', visible);
      }, { threshold: 0 });
      io.observe(btn);
    }

    function render() {
      var s = state();
      var btn = atc();
      label.textContent = s.label;
      price.textContent = s.price;
      action.textContent = s.ready ? 'Toevoegen' : (s.text || 'Kies hoeveelheid');
      action.disabled = s.ready && (!btn || btn.disabled);
      watch();
    }

    action.addEventListener('click', function () {
      var s = state();
      if (!s.ready) {
        var host = bundle ? (bundle.closest('.product-form-block') || bundle) : q('[data-block-id="options"]');
        if (host) host.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var btn = atc();
      if (btn && !btn.disabled) btn.click();
    });

    render();
    setInterval(render, 500);
  }

  var timer = setInterval(function () {
    if (init() || ++tries > 40) clearInterval(timer);
  }, 250);
})();